
// import { AddressAutocompleteComponent } from './address-autocomplete/address-autocomplete.component';
//import { BeneficiaryBoxComponent } from './beneficiary-box/beneficiary-box.component';
import { BoxQuestionComponent } from './box-question/box-question.component';
import { DichotomousQuestionComponent } from './dichotomous-question/dichotomous-question.component';
import { GspInputModalComponent } from './gsp-input-modal/gsp-input-modal.component';
import { PaymentInfoNameComponent } from './payment-info-name/payment-info-name.component';
import { ModalComponent } from './modal/modal.component';
import { QuestionCardComponent } from './question-card/question-card';
import { ConfirmationStepComponent } from './confirmation-step/confirmation-step.component';
import { EditResourceComponent } from './edit-resource/edit-resource.component';
//import { ErrorInfoComponent } from './error-info/error-info.component';
import { WarningQuestionComponent } from './warning-question/warning-question.component';
import { YesNoQuestionListComponent } from './yes-no-question-list/yes-no-question-list.component';
//import { AddBeneficiaryBoxComponent } from './add-beneficiary-box/add-beneficiary-box.component';
import { FaqCategoryComponent } from './faq-category/faq-category.component';
import { UnauthorizedSnackBarBodyComponent } from './unauthorized-snack-bar-body/unauthorized-snack-bar-body.component';
import { adpComplexSelectComponent } from './adp-complex-select/adp-complex-select.component';
import { adpGooglePlacesComponent } from './adp-google-places/adp-google-places.component';
import { adpLoadingDialogComponent } from './adp-loading-dialog/adp-loading-dialog.component';
import { adpModalComponent } from './adp-modal/adp-modal.component';
import { adpPortalProfileMenuComponent } from './adp-portal-profile-menu/adp-portal-profile-menu.component';
import { AssurantLoaderComponent } from './assurant-loader/assurant-loader.component';
import { ImageFileUploaderComponent } from './file-uploader/image-file-uploader.component';
import { FilterComponent } from './filter/filter.component';
import { LoaderProgressComponent } from './loader-progress/loader-progress.component';
import { PortalMenuComponent } from './portal-menu/portal-menu.component';
import { PortalMenuWrapperComponent } from './portal-menu-wrapper/portal-menu-wrapper.component';
import { ProgressStepSpinnerComponent } from './progress-step-spinner/progress-step-spinner.component';
import { SnackBarBodyComponent } from './snack-bar-body/snack-bar-body.component';
import { PortalPanelAccordionComponent } from './portal-panel-accordion/portal-panel-accordion.component';
import { LoginErrorModalComponent } from './login-error-modal/login-error-modal.component';
import { BottomNavBarComponent } from './bottom-nav-bar/bottom-nav-bar.component';
import { YesNoModalComponent } from './yes-no-modal/yes-no-modal.component';
import { MessageDisplayLoaderComponent } from './message-display-loader/message-display-loader.component';
import { ImeiGeneratorComponent } from './imei-generator/imei-generator.component';
import { IbanGeneratorComponent } from "./iban-generator/iban-generator.component";
import { ToastBannerComponent } from './toast-banner/toast-banner.component';
import { ToastBannerWarningComponent } from './toast-banner-warning/toast-banner-warning.component';
import { ToastBannerInformationComponent } from './toast-banner-information/toast-banner-information.component';
import { ButtonToggleFilterComponent } from './button-toggle-filter/button-toggle-filter.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';

export {
    //AddressAutocompleteComponent,
    //BeneficiaryBoxComponent,
    BoxQuestionComponent,
    DichotomousQuestionComponent,
    GspInputModalComponent,
    PaymentInfoNameComponent,
    ModalComponent,
    QuestionCardComponent,
    ConfirmationStepComponent,
    EditResourceComponent,
    // ErrorInfoComponent,
    WarningQuestionComponent,
    YesNoQuestionListComponent,
    //AddBeneficiaryBoxComponent,
    FaqCategoryComponent,
    adpComplexSelectComponent,
    adpGooglePlacesComponent,
    adpLoadingDialogComponent,
    adpModalComponent,
    adpPortalProfileMenuComponent,
    AssurantLoaderComponent,
    ImageFileUploaderComponent,
    FilterComponent,
    LoaderProgressComponent,
    PortalMenuComponent,
    PortalMenuWrapperComponent,
    ProgressStepSpinnerComponent,
    SnackBarBodyComponent,
    UnauthorizedSnackBarBodyComponent,
    PortalPanelAccordionComponent,
    LoginErrorModalComponent,
    BottomNavBarComponent,
    YesNoModalComponent,
    MessageDisplayLoaderComponent,
    IbanGeneratorComponent,
    ToastBannerComponent,
    ToastBannerWarningComponent,
    ToastBannerInformationComponent,
    ButtonToggleFilterComponent
}

export const GSP_COMPONENTS = [
   // AddressAutocompleteComponent,
    //BeneficiaryBoxComponent,
    BoxQuestionComponent,
    DichotomousQuestionComponent,
    GspInputModalComponent,
    PaymentInfoNameComponent,
    ModalComponent,
    QuestionCardComponent,
    ConfirmationStepComponent,
    EditResourceComponent,
    // ErrorInfoComponent,
    WarningQuestionComponent,
    YesNoQuestionListComponent,
    //AddBeneficiaryBoxComponent,
    FaqCategoryComponent,
    adpComplexSelectComponent,
    adpGooglePlacesComponent,
    adpLoadingDialogComponent,
    adpModalComponent,
    adpPortalProfileMenuComponent,
    AssurantLoaderComponent,
    ImageFileUploaderComponent,
    FilterComponent,
    LoaderProgressComponent,
    PortalMenuComponent,
    PortalMenuWrapperComponent,
    ProgressStepSpinnerComponent,
    SnackBarBodyComponent,
    UnauthorizedSnackBarBodyComponent,
    PortalPanelAccordionComponent,
    LoginErrorModalComponent,
    BottomNavBarComponent,
    YesNoModalComponent,
    MessageDisplayLoaderComponent,
    ImeiGeneratorComponent,
    IbanGeneratorComponent,
    PdfViewerComponent,
    ToastBannerComponent,
    ButtonToggleFilterComponent,
    ToastBannerWarningComponent,
    ToastBannerInformationComponent
]
